// extracted by mini-css-extract-plugin
export default {"labelInput":"Input_labelInput__-po1S","valid":"Input_valid__ZxeZw","error":"Input_error__yUczQ","paddingIcon":"Input_paddingIcon__VUf3K"};